import { z } from 'zod';

import { request } from '@/api/httpClient';

export async function getStandardTasks(): Promise<string | null> {
  return z
    .object({ default_checklist: z.string().nullable() })
    .parse(await request<unknown>('/managers/context')).default_checklist;
}
export async function saveStandardTasks(tasks: string[]) {
  await request('/managers/settings/organisation', {
    method: 'PUT',
    body: { default_checklist: JSON.stringify(tasks) },
  });
}
